<template>
  <div class="text-md-left">
    <el-dialog
      width="50%"
      top="3vh"
      :visible.sync="data.dialog"
      custom-class="dialogAddCourierLimit"
      style="font-family: 'Prompt', sans-serif"
      append-to-body
    >
      <template slot="title">
        <h2 style="margin:unset;text-align:left;">เพิ่มขนส่งข้อมูลจำกัดจำนวนออเดอร์ของขนส่ง</h2>
      </template>
      <el-row>
        <el-col
          class="text-md-left"
          :sm="24"
        >
          <el-card
            shadow="never"
            style="padding-bottom:20px;"
          >
            <el-row>
              <el-col class="text-md-left">
                <el-table
                  :data="courierAccounts"
                  stripe
                  :default-sort="{prop: 'courierAccountId', order: 'descending'}"
                  :header-cell-style="{'background-color': 'black', 'color': 'white'}"
                  style="width: 100%"
                >
                  <el-table-column label="ชื่อขนส่ง">
                    <div
                      class="text-md-left"
                      slot-scope="scope"
                    >
                      {{ scope.row.name }}
                    </div>
                  </el-table-column>

                  <el-table-column label="จัดการ">
                    <div
                      class="text-md-left"
                      slot-scope="scope"
                    >
                      <el-button
                        type="primary"
                        @click="handleAddCourierAccount(scope.row.courierId)"
                      >เพิ่ม</el-button>
                    </div>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          @click="data.dialog = false"
          type="danger"
          plain
        >ยกเลิก</el-button>
        <!-- <el-button type="primary" @click="submitEditUser('userForm')">บันทึก</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
export default {
    name: 'dialogAddCourierLimit',
    props: {
        data: {
            type: Object,
            default: null
        }
    },
    data () {
        return {
            courierAccounts: []
        }
    },
    watch: {
        'data.dialog' (val) {
            if (val) {
                this.fetchCourierProvider()
            } else {
                this.courierAccounts = []
            }
        }
    },
    created () {},
    methods: {
        async fetchCourierProvider () {
            let loading = this.$loading({
                target: '.dialogAddCourierLimit',
                text: 'Loading ...'
            })

            try {
                let param = {
                    target_user_id: this.data.userId
                }
                let res = await fgApi.courier.getCourierByUserID(param)
                if (res.success) {
                    let IdShowLish = [1, 4, 9, 10] // [SCG,FLASH,BEST] courierId
                    res.data.autoCourier.map((e) => {
                        res.data.courierAccounts.filter(el => {
                            if (el.courierAccountId === e.courierAccountId) {
                                if (IdShowLish.indexOf(el.courierId) !== -1) {
                                    this.courierAccounts.push({ ...el, day: e.day })
                                }
                            }
                        })
                    })
                }
            } catch (error) {
                console.log(error)
            }
            loading.close()
        },
        handleAddCourierAccount (obj) {
            this.$emit('addCourier', obj)
        }
    }
}
</script>
<style lang="scss">
.dialogAddCourierLimit {
    .el-dialog__header {
        background-color: teal;
        color: white;
        button {
            font-size: large;
            i {
                color: #ffffff;
                &:hover {
                    color: white;
                }
            }
        }
    }
}
</style>
